export default __webpack_public_path__ + "static/media/logo.51a952de.png";